import { FlexBox } from '@ardoq/layout';
import { Text } from '@ardoq/typography';
import { t, type I18nLocale } from '@ardoq/i18n';
import { ButtonSize, GhostButton } from '@ardoq/button';

type HiddenTriplesHintProps = {
  hiddenTriplesCount: number;
  onShowAllClicked: VoidFunction;
  i18nLocale: I18nLocale;
};

export const HiddenTriplesHint = ({
  hiddenTriplesCount,
  onShowAllClicked,
  i18nLocale,
}: HiddenTriplesHintProps) => {
  if (hiddenTriplesCount === 0) {
    return null;
  }

  return (
    <FlexBox gap="small" justify="center" align="baseline">
      <Text color="textSubtle" variant="text2">
        {hiddenTriplesCount === 1
          ? t(
              i18nLocale,
              'viewpointBuilder:editTraversal.hiddenReferencesSingular',
              '1 reference with zero instances hidden'
            )
          : t(
              i18nLocale,
              'viewpointBuilder:editTraversal.hiddenReferencesPlural',
              { count: hiddenTriplesCount },
              '{{count}} references with zero instances hidden'
            )}
      </Text>
      <GhostButton
        onClick={onShowAllClicked}
        buttonSize={ButtonSize.SMALL}
        aria-label={t(
          i18nLocale,
          'viewpointBuilder:editTraversal.showAllReferences',
          'Show all references'
        )}
      >
        {t(i18nLocale, 'viewpointBuilder:editTraversal.showHidden', 'Show')}
      </GhostButton>
    </FlexBox>
  );
};
